import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const getTopBuyers = async (groupId, limit = 10, startDate = null, endDate = null) => {
  if (!groupId) {
    console.error('Group ID no proporcionado');
    return [];
  }

  try {
    const getBuyersFn = httpsCallable(functions, 'getTopBuyersV2');
    const result = await getBuyersFn({
      groupId,
      requestedApp: 'group_web',
      limit,
      startDate: startDate instanceof Date ? startDate.getTime() : null,
      endDate: endDate instanceof Date ? endDate.getTime() : null,
    });

    if (Array.isArray(result.data)) {
      return result.data;
    }
    if (result.data && result.data.success === 'yes') {
      return result.data.data || [];
    }
    return [];
  } catch (error) {
    console.error('Error obteniendo compradores principales:', error);
    notifyPermissionDenied(error);
    return [];
  }
};
